import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

let ScrollTriggerInit = gsap.registerPlugin( ScrollTrigger );

if ( $( '.parallax-scroll' ).length ) {
  ScrollTriggerInit;

  var parallaxImage = document.querySelectorAll( '.parallax-image' );

  if ( $( '.logo-animate' ).length ) {
    ScrollTrigger.create( {
      trigger: '.logo-animate',
      start: 'top 30%',
      end: 'bottom-=100 bottom-=30%',
      toggleClass: 'active',
      pin: true,
      scrub: 3,
      // remove ScrollTrigger height
      onUpdate: () => $( '.logo-animate' ).css( 'height', '360px' )
    });
  }

  if ( $( '.parallax-image' ).length ) {
    parallaxImage.forEach( ( image, i ) => {
      gsap.to( image, {
        yPercent: -200,
        scrollTrigger: {
          trigger: image,
          start: 'top center',
          scrub: 3
        }
      });
    });
  }
}

if( $( '.parallax-hero-scroll' ).length  ) {
  ScrollTriggerInit

  var parallaxHeroImage = document.querySelectorAll( '.parallax-hero-images' );

  if ( $( '.parallax-hero-images' ).length ) {
    parallaxHeroImage.forEach( ( image, i ) => {
      gsap.to( image, {
        yPercent: -50,
        scrollTrigger: {
          trigger: image,
          start: 'top center',
          scrub: 2
        }
      });
    });
  }
}

if( $( '.flip-card' ).length ) {
  var flipCards = document.querySelectorAll( '.flip-card' )

  flipCards.forEach( ( elem ) => {
    $( elem ).on( 'click', () => {
      $( elem ).toggleClass( 'flipped' )
    })
  })
}

if( $( '.load-more' ).length ) {
  var loadMore = document.querySelectorAll( '.load-more' )

  loadMore.forEach( ( elem ) => {

    $( elem ).on( 'click', () => {
      if( $( elem ).parent().siblings().find( '.show-more-card' ).hasClass( 'hide-card' ) ) {
        $( elem ).parent().siblings().find( '.show-more-card' ).removeClass( 'hide-card' )
        $( elem ).text( "Load Less" )
      } else {
        $( elem ).parent().siblings().find( '.show-more-card' ).addClass( 'hide-card' )
        $( elem ).text( "Load More" )
      }
    } )
  } )
}